import { formatDate } from '@angular/common';
import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { MapPopupComponent } from '../map-popup/map-popup.component';

@Component({
  selector: 'app-user-latest-location',
  templateUrl: './user-latest-location.component.html',
  styleUrls: ['./user-latest-location.component.css']
})
export class UserLatestLocationComponent implements OnInit {

  private map!: L.Map;
  private centroid: L.LatLngExpression = [42.3601, -71.0589];
  // private centroid1: L.LatLngExpression = [32.3601, -31.0589];
  usersList: any= []
  cid:any
  date1:any
  date2: any
  search = ""
  useremail: any;
  username: any;
  lat: any = [];
  lon: any = [];
  name: any = "";

  isSelectAll = false
  listOfTracking: any = [];
  lastUserIdChecked: any
  lastUserIdCheckedLoc: any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector
  ) { }

  ngOnInit(): void {

    this.cid = sessionStorage.getItem('cid')
    this.getUsersWithoutCustomers()
    this.date2 = new Date()
    this.date2.setDate(this.date2.getDate()+1);
    this.date2 = formatDate(this.date2, 'yyyy-MM-dd', 'en-US')
    console.log(new Date(this.date2).getTime())
    this.date1 = new Date()
    this.date1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')

  }

  private centroid1: L.LatLngExpression[]= [];

  hyderabadLoc: L.LatLngExpression[]= [[17.3850, 78.4867]]

  initMap(): void {
    let ct:any = []
    if(this.centroid1.length == 0) {
      ct.push(this.hyderabadLoc[0])
    }else{
      if(this.lastUserIdCheckedLoc.length != 0 ){
        ct.push(this.lastUserIdCheckedLoc[0])
      }else{
        ct.push(this.centroid1[0])
      }
    }
    this.map = L.map('map', {
      center: ct[0],
      zoom: 16
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    if(this.centroid1.length != 0){
      for(let i = 0; i < this.centroid1.length; i++){
        let markerPopup: any = this.compilePopup(MapPopupComponent,(c:any) => {c.instance.customData = this.listOfTracking[i]});

        let loc = L.marker(this.centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup(markerPopup).openPopup()
        loc.addTo(this.map)
       }
       tiles.addTo(this.map);
    }else{
      tiles.addTo(this.map);
    }

  }

  defaultIcon = L.icon({
    iconUrl: 'assets/4899329.png', // your path may vary ...
    iconSize: [80, 80],
    iconAnchor: [2, 2],
    popupAnchor: [40, -4]
  });

  ngOnDestroy(){
    console.log("ngOnDestroy")
    this.map.remove();
  }

  // getUsers(){
  //   this.generic_service.getUsers().subscribe(
  //     (res:any)=>{
  //       this.usersList = res.response;
  //       console.log(this.usersList)
  //     }
  //   )
  // }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{

        let list: any = []

        for(let i = 0; i < res.response.length; i++){
          if(res.response[i].keyValues != null && res.response[i].keyValues.length != 0 && res.response[i].keyValues != undefined){
            for(let j = 0; j < res.response[i].keyValues.length; j++){
              if(res.response[i].keyValues[j].key.toLowerCase() == "usertracking"){
                if(res.response[i].keyValues[j].value.toLowerCase() == "true"){
                  list.push(res.response[i])
                }
              }
            }
          }
        }
        this.usersList = list;
        console.log(res)
        console.log(this.usersList)
        this.initMap();

      }
    )
  }

  getName(event:any){
    console.log(event)
  }

  getEmployeeLocationTrackingByIdAndBetweenDates(userId: any, event:any){
    this.generic_service.getEmployeeLocationTrackingByIdAndBetweenDates(userId,new Date(this.date1).getTime(),new Date(this.date2).getTime()).subscribe(
      (res: any)=>{
        console.log(res)

        this.map.remove();
        this.centroid1 = []
        if(res.response.length != 0){
          for(let i = 0; i < res.response.length; i++){
            if(res.response[i].latitude != null && res.response[i].latitude != "" && res.response[i].latitude != undefined){
              let ct:any = [res.response[i].latitude,res.response[i].longitude]
              this.centroid1.push(ct)
            }
          }
          this.initMap()
        }else{
          //  this.centroid1.push([17.3850, 78.4867])
           this.initMap()

        }
        console.log(this.centroid1)
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }


  getEmployeeLocationTrackingByIdAndLastDatetime(){
    let userIds: any = ""

    for(let i = 0; i < this.usersList.length; i++){
      if(this.usersList[i].isChecked){
        userIds += ","+this.usersList[i].userId
      }
    }
    userIds = userIds.slice(1)
    console.log(userIds)
    this.generic_service.getEmployeeLocationTrackingByIdAndLastDatetime(userIds).subscribe(
      (res: any)=>{
        console.log(res)
        this.listOfTracking = res.response.listOfTracking
        this.map.remove();
        this.centroid1 = []
        this.lastUserIdCheckedLoc = []
        if(res.response.length != 0){
          for(let i = 0; i < res.response.listOfTracking.length; i++){
            if(res.response.listOfTracking[i].latitude != null && res.response.listOfTracking[i].latitude != "" && res.response.listOfTracking[i].latitude != undefined){
              let ct:any = [res.response.listOfTracking[i].latitude,res.response.listOfTracking[i].longitude]
              this.centroid1.push(ct)
              if(res.response.listOfTracking[i].userId == this.lastUserIdChecked){
                this.lastUserIdCheckedLoc.push(ct)
                console.log(this.lastUserIdCheckedLoc)
                console.log('user id')

              }
            }
          }
          this.initMap()
        }else{
          //  this.centroid1.push([17.3850, 78.4867])
           this.initMap()

        }

        for(var j =0;j<this.usersList.length;j++){
          this.usersList[j].trackingData = []
        }

        for(var i =0;i<this.listOfTracking.length;i++){
          for(var j =0;j<this.usersList.length;j++){
            if(this.listOfTracking[i].userId == this.usersList[j].userId){
              this.usersList[j].trackingData = this.listOfTracking[i]
              this.listOfTracking[i].userName = this.usersList[j].userName
            }
          }
        }
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  getEmployeLocation(useremail:any, event:any){

    console.log(event)
    this.name = event.target.__ngContext__[22]

    let body = {
      "startDate": new Date(this.date1).getTime(),
      "endDate": new Date(this.date2).getTime(),
      "cid": this.cid,
      "username": useremail
    }

    console.log(body)
    this.generic_service.getAllByCidAndBetweenDates(body).subscribe(
      (res:any)=>{
        this.map.remove();
        this.centroid1 = []
        console.log(res)
        console.log(res.response)
        
        if(res.response.length != 0){
          for(let i = 0; i < res.response.length; i++){
            let ct:any = [res.response[i].latitude,res.response[i].longitude]
            this.centroid1.push(ct)
          }
          this.initMap()
        }else{
          //  this.centroid1.push([17.3850, 78.4867])
           this.initMap()

        }
        console.log(this.centroid1)

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  selectAllToggle(toggle: any){
    if(toggle == "select all"){
      this.isSelectAll = true
      for(let i = 0; i < this.usersList.length; i++){
        this.usersList[i].isChecked = true
      }
    }

    if(toggle == "deselect all"){
      this.isSelectAll = false
      for(let i = 0; i < this.usersList.length; i++){
        this.usersList[i].isChecked = false
      }
    }
  }


  compilePopup(component:any, onAttach:any): any {
    const compFactory: any = this.resolver.resolveComponentFactory(component);
    let compRef: any = compFactory.create(this.injector);

    // onAttach allows you to assign 
    if (onAttach)
      onAttach(compRef);

    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));
    
    let div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }

  userChecked(event: any,userId: any){
    console.log(event.target.checked)
    console.log(userId)
    this.lastUserIdChecked = userId
    console.log(this.lastUserIdChecked)

    for(let list of this.usersList){
      if(list.userId == userId){
        list.isChecked = event.target.checked
      }
    }
    this.getEmployeeLocationTrackingByIdAndLastDatetime()
  }

  setCenter(userId: any){
    console.log(userId)
    this.lastUserIdChecked = userId
    this.getEmployeeLocationTrackingByIdAndLastDatetime()

  }
}